import Layout from "@/components/Layout";
import PrivateRoute from "@/components/PrivateRoute";
import LoginPage from "@/pages/login/LoginPage";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { routes } from "./routes";
import { ROUTE } from "@/types/router";
import { useUserStore } from "@/zustand/user";

const RootNavigation = () => {
  const { user } = useUserStore();
  return (
    <BrowserRouter>
      <Routes>
        <Route path={ROUTE.Login} element={<LoginPage />} />
        <Route element={<PrivateRoute isAuth={user.isLogin} />}>
          <Route element={<Layout />}>
            {routes.map((route) => (
              <Route
                key={route.path}
                path={route.path}
                element={route.element}
              />
            ))}
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default RootNavigation;
